module.exports = __webpack_public_path__ + "img/vlcsnap-2024-01-09-21h19m04s338.45bb4973.png";